import styled from "styled-components";
// import GlobalStyle from "../../../GlobalStyle";
import tick1 from "../../../assets/img/icons/tick.svg";
import { removeOnClickBubble } from "utils";

const InputWrapper = styled.div`
  position: relative;
  display: inline;
  float: left;
  margin-right: 7px;
  margin-top: 4px;
  align-self: ${(props) => (props.alignSelf ? "center" : "unset")};
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-top: 3px;
  }
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  label {
    margin: 0px !important;
    span {
      padding: 8px;
      height: ${(props) => (props.height ? props.height : "18px")};
      width: ${(props) => (props.width ? props?.width : "18px")};
      ${(props) => (props.borderless ? "background-size: contain" : "border: 2px solid #c3c3c3")};
      border-radius: 5px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center center;
      ${(props) => (props?.backgroundColor ? `background-color: ${props?.backgroundColor}` : "")};
      transition: all 300ms;
      display: block;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: ${(props) => (props.height ? props.height : "14px")};
        width: ${(props) => (props.width ? props?.width : "14px")};
        padding: 6px;
        background-size: 10px;
      }
    }
  }
`;

const Input = styled.input`
  visibility: hidden;
  position: absolute;
  top: 3px;
  left: 3px;
  &:checked + span {
    background-image: url(${tick1});
    border-color: #1ec252;
  }
  &:active + span,
  &:focus + span {
    box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
    outline: none;
  }
`;

const Checkbox = (props) => {
  return (
    <>
      {/* comment out the following styled component to improve the performance. */}
      {/* <GlobalStyle /> */}
      <InputWrapper
        className={props.disabled ? "disabled" : ""}
        onClick={(e) => removeOnClickBubble(e)}
        {...(props?.alignSelf ? { alignSelf: props?.alignSelf } : {})}
        {...(props?.borderless ? { borderless: props?.borderless } : {})}
        {...(props?.height ? { height: props?.height } : {})}
        {...(props?.width ? { width: props?.width } : {})}
        {...(props?.backgroundColor ? { backgroundColor: props?.backgroundColor } : {})}
        {...(props?.readOnly ? { readOnly: props?.readOnly } : {})}
      >
        <label>
          <Input {...props} type="checkbox" className={props.className}{...(props.onChange ? { onChange: props.onChange } : {})} />
          <span></span>
        </label>
      </InputWrapper>
    </>
  );
};

export default Checkbox;

Checkbox.defaultProps = {
  borderless: false,
  disabled: false,
};
